document.addEventListener('DOMContentLoaded', function() {
  
    /** Helper functions 
     *  _$ - single element selector, defaults to document but can accept context
     * _$$ - multiple elements selector, defaults to document but can accept context, can return NodeList or Array based on third parameter
     * normalizePrice - takes a price string, removes currency symbols, handles different decimal separators, and returns a float. If isGetMoney is true, it formats the price as money string.
     * */ 

  // https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c?permalink_comment_id=5081916#gistcomment-5081916
  
  const moneyFormat = _$('#money-format').value;
 const formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
    cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
  };

  function _$(selector, context = document) {
    return context.querySelector(selector)
  }
  function _$$(selector, context = document, toSimpleArray = false) {
    const arr = context.querySelectorAll(selector)
    return toSimpleArray ? Array.from(arr) : arr
  }
  function normalizePrice(priceString, isGetMoney = false) {
    if (!priceString) return null;

    // console.log('Normalizing price:', priceString, `(isGetMoney: ${isGetMoney})`)

    if (typeof priceString === 'number') {
      priceString = priceString.toFixed(2);
    }

    // Remove currency symbols and spaces
    let cleaned = priceString
      .replace(/[^\d.,-]/g, '') // keep digits, dot, comma, minus
      .trim();

    // If both comma and dot exist → determine decimal separator
    if (cleaned.includes(',') && cleaned.includes('.')) {
      // If comma appears after dot → comma is decimal
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    }
    // If only comma exists → assume decimal comma
    else if (cleaned.includes(',')) {
      cleaned = cleaned.replace(',', '.');
    }

    if (isGetMoney) {
      return formatMoney(cleaned, moneyFormat);
    }

    return parseFloat(cleaned);
  }


  const firstProductCategory = _$$('.ssb--toggler__btn')[0]?.getAttribute('data-category');
  const secondProductCategory = _$$('.ssb--toggler__btn')[1]?.getAttribute('data-category');

  const firstLeftImageDeskEl = _$('.section-cover-img-desk.ssb--slide-img-first');
  const secondLeftImageDeskEl = _$('.section-cover-img-desk.ssb--slide-img-second');
  const firstLeftImageMobEl = _$('.section-cover-img-mob.ssb--slide-img-first');
  const secondLeftImageMobEl = _$('.section-cover-img-mob.ssb--slide-img-second');

  _$(`.ssb--toggler__btn[data-category="${firstProductCategory}"]`).addEventListener('click', (e) => {
    if (e.target.classList.contains('active')) return;
    e.target.classList.add('active');
    _$$('.ssb--package__image-first').forEach(img => img.classList.add('active'));
    _$$('.ssb--package__image-second').forEach(img => img.classList.remove('active'));
    _$$('.ssb--bundle__image-first').forEach(img => img.classList.add('active'));
    _$$('.ssb--bundle__image-second').forEach(img => img.classList.remove('active'));
    _$(`.ssb--toggler__btn[data-category="${secondProductCategory}"]`).classList.remove('active');

    _$('.ssb--bundle').setAttribute('data-id', _$('.ssb--bundle').dataset.bundleId)
    _$$('.ssb--bundle-included.first').forEach(img => img.style.display = 'block');
    _$$('.ssb--bundle-included.second').forEach(img => img.style.display = 'none');

    _$('.ssb--bundle__title.first').style.display = 'block';
    _$('.ssb--bundle__title.second').style.display = 'none';


    if(firstLeftImageDeskEl || secondLeftImageDeskEl) {
        firstLeftImageDeskEl.classList.add('active');
        secondLeftImageDeskEl.classList.remove('active');
        
    }
    if(firstLeftImageMobEl || secondLeftImageMobEl) {
      firstLeftImageMobEl.classList.add('active');
      secondLeftImageMobEl.classList.remove('active');
    }
  });

   _$(`.ssb--toggler__btn[data-category="${secondProductCategory}"]`).addEventListener('click', (e) => {
      if (e.target.classList.contains('active')) return;

      e.target.classList.add('active');
      _$$('.ssb--package__image-first').forEach(img => img.classList.remove('active'));
      _$$('.ssb--package__image-second').forEach(img => img.classList.add('active'));
      _$$('.ssb--bundle__image-first').forEach(img => img.classList.remove('active'));
      _$$('.ssb--bundle__image-second').forEach(img => img.classList.add('active'));
      _$(`.ssb--toggler__btn[data-category="${firstProductCategory}"]`).classList.remove('active');

       _$('.ssb--bundle').setAttribute('data-id', _$('.ssb--bundle').dataset.secondBundleId)
      _$$('.ssb--bundle-included.first').forEach(img => img.style.display = 'none');
      _$$('.ssb--bundle-included.second').forEach(img => img.style.display = 'block');

      _$('.ssb--bundle__title.first').style.display = 'none';
      _$('.ssb--bundle__title.second').style.display = 'block';


      if(firstLeftImageDeskEl || secondLeftImageDeskEl) {
        firstLeftImageDeskEl.classList.remove('active');
        secondLeftImageDeskEl.classList.add('active');
        
      }
      if(firstLeftImageMobEl || secondLeftImageMobEl) {
        firstLeftImageMobEl.classList.remove('active');
        secondLeftImageMobEl.classList.add('active');
      }
    });

  let isOpenDisableTrigger = false;
  _$('.ssb--subscr__select').addEventListener('change', (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex].textContent.replace('Ship every: ', '');
    _$('.ssb--subscr__selector-value span').textContent = selectedOption;

    isOpenDisableTrigger = true;
    setTimeout(() => {
      isOpenDisableTrigger = false;
    }, 200);
  })

  // Pack click handler
     _$$(".ssb--package").forEach((pack) => {
      pack.addEventListener('click', () => {
        _$('.ssb--bundle.active')?.classList.remove('active');
        if (pack.classList.contains('active')) return;
        _$('.ssb--packages__list .ssb--package.active')?.classList.remove('active');
        pack.classList.add('active');
        updatePrices();
      });
     })

    //  Bundle click handler
      _$('.ssb--bundle').addEventListener('click', () => {
      if (_$('.ssb--bundle').classList.contains('active')) return
      _$('.ssb--bundle').classList.add('active');
      _$('.ssb--packages__list .ssb--package.active')?.classList.remove('active');
      updatePrices();
    });

    // Plan click handler
    _$$('.ssb--plan').forEach(plan => {
      plan.addEventListener('click', () => {
        if (plan.classList.contains('active')) return;

        const selectedPlan = plan.dataset.plan
        if (selectedPlan === 'one-time' && _$('.ssb--upsell__subscr.active')) {
          $('.ssb--upsell__subscr').slideUp().removeClass('active');
        } else if (selectedPlan === 'subscription' && parseInt(_$('.ssb--upsell__counter-value').textContent) > 0) {
          $('.ssb--upsell__subscr').slideDown().addClass('active');
        }

        if (selectedPlan === 'one-time') {
          $('.ssb--subscr').slideUp().removeClass('active');
        //   $('.ssb--bundle__wrap').slideDown().removeClass('active');
        } else {
          $('.ssb--subscr').slideDown().addClass('active');
        //   $('.ssb--bundle__wrap').slideUp().removeClass('active');
        }

        // Reset to default package when switching plans
        if(selectedPlan === 'subscription' && _$('.ssb--bundle.active')) {
          _$('.ssb--bundle.active').classList.remove('active');
          _$('.ssb--package[data-pack="3"]').classList.add('active');
        }

        _$('.ssb--plan.active')?.classList.remove('active');
        plan.classList.add('active');
        updatePrices();
      })
    })

    // Locket counter handlers
        _$('.ssb--upsell__counter-btn--minus').addEventListener('click', () => {
      const valueEl = _$('.ssb--upsell__counter-value')
      let value = parseInt(valueEl.textContent)

      if (value > 0) {
        value--
        valueEl.textContent = value
      }

      checkSubscrBtns(value)
    })

    // Locket counter handlers
    _$('.ssb--upsell__counter-btn--plus').addEventListener('click', () => {
      const valueEl = _$('.ssb--upsell__counter-value')
      let value = parseInt(valueEl.textContent)

      value++
      valueEl.textContent = value

      checkSubscrBtns(value)
    })

    // Subscription toggle handlers
    _$$('.ssb--upsell__subscr-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('active')) return;

        _$('.ssb--upsell__subscr-btn.active')?.classList.remove('active');
        btn.classList.add('active');
        updatePrices();
      })
    })

    // Proceed to cart handler
    _$('.ssb--proceed').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      addToCart();
    })

   function checkSubscrBtns(value) {
      if (value > 0 && _$('.ssb--plan.active')?.dataset.plan === 'subscription') {
        $('.ssb--upsell__subscr').slideDown().addClass('active');
      } else {
        $('.ssb--upsell__subscr').slideUp().removeClass('active');
      }
      updatePrices();
    }
    

   function updatePrices() {
    const isLocketSubscr = _$('.ssb--upsell__subscr.active') && _$('.ssb--upsell__subscr-btn.active')?.dataset.subscription === 'true';
    const targetPackage = _$('.ssb--package.active') || _$('.ssb--bundle.active');
    const oneTimePrice = targetPackage?.dataset.price;
    const subscriptionPrice = targetPackage?.dataset.subscriptionPrice;
    const oldPrice = targetPackage?.dataset.oldPrice;

    _$('[data-plan="one-time"] .ssb--plan__price-new').textContent = oneTimePrice;
    _$('[data-plan="subscription"] .ssb--plan__price-old').textContent = oneTimePrice;
    _$('[data-plan="subscription"] .ssb--plan__price-new').textContent = subscriptionPrice;

    if (!isLocketSubscr) {
      _$(".ssb--upsell__title-price").classList.remove('active');
      _$(".ssb--upsell__title-price").textContent = _$('.ssb--upsell').dataset.price;
    } else {
      _$(".ssb--upsell__title-price").classList.add('active');
      _$(".ssb--upsell__title-price").textContent = _$('.ssb--upsell').dataset.subscribedPrice;
    }

    const isSubscription = _$('.ssb--plan.active')?.dataset.plan === 'subscription';

    _$$('.ssb--package').forEach(packageEl => {
      const price = isSubscription ? packageEl.dataset.subscriptionPrice : packageEl.dataset.price;
      const oldPrice = packageEl.dataset.oldPrice;
      const perPatch = isSubscription ? packageEl.dataset.subscriptionPerPatch : packageEl.dataset.perPatch;
      
      packageEl.querySelector('.ssb--package__price-new').textContent = price;
      packageEl.querySelector('.ssb--package__price-old').textContent = oldPrice;
      packageEl.querySelector('.ssb--package__per-patch span').textContent = perPatch;
    })

    _$$('.ssb--bundle__price-value').forEach(priceEl => {
      const price = isSubscription ? _$('.ssb--bundle').dataset.subscriptionEachPrice : _$('.ssb--bundle').dataset.eachPrice;

      priceEl.textContent = price;
    })

    let regularPrice = 0;
    let totalPrice = 0
    console.log('** Price calculation: **')

    const locketCount = parseInt(_$('.ssb--upsell__counter-value').textContent);
    if (locketCount > 0) {
      const locketsPrice = normalizePrice(_$('.ssb--upsell').dataset.price) * locketCount;
      const actualLocketPrice = normalizePrice(isLocketSubscr ? _$('.ssb--upsell').dataset.subscribedPrice : _$('.ssb--upsell').dataset.price) * locketCount;

      console.log('----- Lockets:', locketsPrice, actualLocketPrice, `(count: ${locketCount}, subscribed: ${isLocketSubscr})`)

      totalPrice += actualLocketPrice;
      regularPrice += locketsPrice;
    }

    const packagePrice = isSubscription ? subscriptionPrice : oneTimePrice;
    totalPrice += normalizePrice(packagePrice);
    regularPrice += normalizePrice(oldPrice);
    console.log(`----- ${_$('.ssb--bundle.active') ? 'Bundle' : 'Package'} Price:`, normalizePrice(packagePrice), normalizePrice(oldPrice))

    let savePrice = regularPrice - totalPrice;
    const saveProcent = regularPrice > 0 ? Math.round((savePrice / regularPrice) * 100) : 0;
    totalPrice = normalizePrice(totalPrice, true);
    regularPrice = normalizePrice(regularPrice, true);
    savePrice = normalizePrice(savePrice, true);

    _$('.overall-price .ssb--price-num').textContent = totalPrice;
    _$('.overall-price .ssb--price-off').textContent = saveProcent;
    _$('.purchase__regular-price .ssb--compare-price').textContent = regularPrice;
    _$('.purchase__regular-price .ssb--saved-price').textContent = savePrice;

  }

  function init() {
    updatePrices()
  }
  init()

    async function addToCart() {
    if (_$('.ssb--proceed').classList.contains('ssb--disabled')) return;

    _$('.ssb--proceed').classList.add('ssb--disabled');
    _$('.ssb--proceed').textContent = 'Processing...';

   const petLocketId = _$('.ssb--upsell').getAttribute('data-id');

    
    const productConfig = {
      // dog: {
      //   1: '43536637886508',
      //   2: '43536637919276',
      //   3: '43536637853740',
      //   4: '43536637952044'
      // },
      // cat: {
      //   1: '44853443723308',
      //   2: '44853443756076',
      //   3: '44853443788844',
      //   4: '44853443821612'
      // },
      // bundle: {
      //   dog: '43842554855468',
      //   cat: '45389241712684'
      // },
      locket: petLocketId
    }

    const isSubscription = _$('.ssb--plan.active')?.dataset.plan === 'subscription';
    const subscriptionId = isSubscription ? _$('.ssb--subscr__select').value : null;

    const isBundle = _$('.ssb--bundle').classList.contains('active');
    

    const formData = new FormData();
    let counter = 0;

    const isLocket = parseInt(_$('.ssb--upsell__counter-value').textContent) > 0;
    const isLocketSubscr = isLocket && _$('.ssb--upsell__subscr.active') && _$('.ssb--upsell__subscr-btn.active').dataset.subscription === 'true';
    if (isLocket) {
      formData.append(`items[${counter}][id]`, productConfig.locket);
      formData.append(`items[${counter}][quantity]`, parseInt(_$('.ssb--upsell__counter-value').textContent));
      if (isLocketSubscr) {
        formData.append(`items[${counter}][selling_plan]`, subscriptionId);
      }
      counter++;
    }

    if (isBundle) {
      // const bundleType = _$('.ssb--toggler__btn[data-category="dogs"]').classList.contains('active') ? 'dog' : 'cat';
      // formData.append(`items[${counter}][id]`, productConfig.bundle[bundleType]);
      const bundleId = _$('.ssb--bundle').getAttribute('data-id');
      formData.append(`items[${counter}][id]`, bundleId);
      formData.append(`items[${counter}][quantity]`, 1);
      if (isSubscription) {
        formData.append(`items[${counter}][selling_plan]`, subscriptionId);
      }
      counter++;
    } else {
      const activePack = _$('.ssb--packages__list .ssb--package.active');
      const packCount = activePack.dataset.pack;

      const productType = _$(`.ssb--toggler__btn[data-category="${firstProductCategory}"]`).classList.contains('active') ? 'first' : 'second';
      // const variantId = productConfig[productType][packCount];
      const variantId = activePack.getAttribute(`data-${productType}-id`);
      formData.append(`items[${counter}][id]`, variantId);
      formData.append(`items[${counter}][quantity]`, 1);
      if (isSubscription) {
        formData.append(`items[${counter}][selling_plan]`, subscriptionId);
      }
      counter++;
    }
    

    try {
      await fetch('/cart/clear.js', { method: 'POST' })
      const addToCartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })

      const addToCartResult = await addToCartResponse.json();
      console.log('Add to cart result:', addToCartResult);
      if (addToCartResult.items?.length) {
        window.location.href = '/checkout';
      } else {
        alert(addToCartResult.message + '\n' + addToCartResult.description);
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('An error occurred while adding the product to the cart. Please try again.');
    } finally {
      setTimeout(() => {
        _$('.ssb--proceed').classList.remove('ssb--disabled');
        _$('.ssb--proceed').textContent = _$('.ssb--proceed').getAttribute('data-name');
      }, 2500);
    }
  }
})